<template>
  <div class="content">
    <controlbar
      :dispItems="reserves"
      @input-event="setReserves"
      @list-reload="reload"
    >
    </controlbar>

    <div class="download">
      <div class="info">{{ info }}</div>
      <li class="download_li">
        <input
          type="button"
          :value="downloadLabel"
          class="setting_post_button"
          @click="showDownloadModal = true"
        />
      </li>
    </div>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="name_label">
              {{ nameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="timelabel">
              {{ reserveDateLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="status_label">
              {{ statusLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispReserves in reserves"
            :key="dispReserves.reserveId"
          >
            <th class="table_checkbox">
              <input
                v-if="!isApply(dispReserves)"
                type="checkbox"
                class="checkbox"
                v-model="dispReserves.checked"
                @click="checkedAction(dispReserves)"
              />
              <input v-else type="checkbox" class="checkbox invisible" />
            </th>
            <td class="table_contents" @click="setActive(dispReserves)">
              <label class="name_label">
                {{ dispReserves.name }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispReserves)">
              <label class="timelabel">
                {{ formatedDate(dispReserves.time) }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispReserves)">
              <label class="status_label">
                {{ dispReserves.statusText
                }}{{ formatedCheckedDate(dispReserves.statusDate) }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setReserves(page - 1)"
      >
      </pagination>
    </div>
    <div class="download_modal_window" v-if="showDownloadModal">
      <downloadModalWindow
        :question="downloadWord"
        @close="stayClose"
        @downloadFile="downloadTemplate"
      >
      </downloadModalWindow>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <falseModalWindow :question="completeWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import downloadModalWindow from '../modalWindow/downloadModalWindow.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      info:
        'ケアワーカー/拠点/所属を一括で更新する予約を行えます。\n予約日時を目安に実行されますが、状況によっては予約日時より遅れる場合がありますので、あらかじめご了承ください。',
      downloadLabel: 'テンプレートのダウンロード',
      nameLabel: '予約名',
      reserveDateLabel: '予約日時',
      statusLabel: '実行状況',
      completeWord: '',
      showDownloadModal: false,
      showFalseModal: false,
      showCompleteModal: false,
      windowHeight: '',
      downloadWord: 'テンプレートのダウンロードを行いますか？',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    reserves() {
      return this.$store.state.reserve.reserves
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.reserve.total) {
        return this.$store.state.reserve.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.reserve.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.reserve.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('reserve/clearSelectedReserveList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setReserves(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    downloadModalWindow,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    isApply(reserve) {
      return !(reserve.applyDate === null || reserve.applyDate === undefined)
    },
    formatedCheckedDate(unixTime) {
      return unixTime ? ` (${this.formatedDate(unixTime)})` : ''
    },
    formatedDate(unixTime) {
      const targetDate = new Date(unixTime)
      return `${targetDate.getFullYear()}/${(targetDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${targetDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${targetDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${targetDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}`
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.reserves.length; i++) {
        if (this.isApply(this.reserves[i])) {
          continue
        }
        this.reserves[i].checked = this.checked
      }
      this.$store.dispatch('reserve/updateSelectedReserveList', this.reserves)
    },
    checkedAction(reserve) {
      reserve.checked = !reserve.checked
      this.$store.dispatch('reserve/updateSelectedReserveList', [reserve])
    },
    close(e) {
      this.showDownloadModal = false
      this.showFalseModal = false
      this.showCompleteModal = false
    },
    stayClose(e) {
      this.showDownloadModal = false
      this.showCompleteModal = false
    },
    async reload() {
      this.$store.dispatch('reserve/clearSelectedReserveList')
      await this.setReserves(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setReserves(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('reserve/setReserves', {
          pageNo: pageNo
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 9
        let reason = 'MSGCRC0216 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0216.name +
            this.errorMsg.MSGCRC0216.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('reserve/setDetailReserve', payload)
        if (location.pathname !== '/reserve/detail') {
          this.$router.push('../reserve/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 9
        let reason = 'MSGCRC0217 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0217.name +
            this.errorMsg.MSGCRC0217.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async downloadTemplate() {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('reserve/downloadTemplate', {})
        const downloadType = this.$store.state.reserve.templateContentType
        const downloadFile = this.$store.state.reserve.templateData
        let link = document.createElement('a')
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([downloadFile], {type: downloadType})
          window.navigator.msSaveOrOpenBlob(blob, '更新予約テンプレート.xlsx')
          this.completeWord = 'ダウンロードしました。'
          this.showCompleteModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([downloadFile], {type: downloadType})
          link.setAttribute('download', '更新予約テンプレート.xlsx')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.completeWord = 'ダウンロードしました。'
          this.showCompleteModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([downloadFile], {type: downloadType})
          link.setAttribute('download', '更新予約テンプレート.xlsx')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.completeWord = 'ダウンロードしました。'
          this.showCompleteModal = true
        }
        if (downloadFile === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_700001
          let eventType = 9
          let reason = 'MSGCRC0220'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0220.name +
            this.errorMsg.MSGCRC0220.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
          this.showloadingModal = false
          return
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0220 '
          this.falseWord =
            this.errorMsg.MSGCRC0220.name +
            this.errorMsg.MSGCRC0220.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
td {
  width: 25%;
}
.info {
  margin: 10px 20px;
  white-space: pre-line;
}
.download {
  display: flex;
  justify-content: space-between;
}
.download_li {
  margin: 10px;
  display: table-cell;
}
.setting_post_button {
  width: 190px;
  height: 40px;
  color: #fff;
  border-radius: 3px;
  margin: 0 8px 0 0;
  border: none;
  background-color: #00afa8;
}
.table_scroll {
  overflow-y: scroll;
  height: calc(100vh - 220px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/reserve/reserveList.vue